<ng-container *ngIf="!hideLibraryHeader && sideBarDocumentRef">
  <div edsSpacing="lg">
    <eds-banner-standard-gradient
      [basicLayout]="true"
      [title]="translationLabel?.insightsTitle"
    >
      <ft-insights-filters
        [aggregation]="aggregations"
        [translationLabel]="translationLabel"
        [displayOptions]="displayOptions"
        (filtered)="onFiltered()"
        (searchTerm)="termSearch($event)"
      ></ft-insights-filters>
    </eds-banner-standard-gradient>
  </div>
</ng-container>

<ng-container *ngIf="hideSidebars">
  <ng-container *ngTemplateOutlet="resultsList"></ng-container>
</ng-container>

<ng-container *ngIf="!isDebugMode && !hideSidebars">
  <section edsSpacing="xxl" edsGrid *ngIf="!isDebugMode">
    <div class="container container--wide">
      <div class="row">
        <!-- main col -->
        <!-- Col 1 -->
        <div
          *ngIf="
            sideBarDocumentRef?.collection?.length > 0 ||
            sideBarDocumentRef?.collections?.length > 0
          "
          edsCol
          [ngStyle]="{ position: 'relative' }"
          [columnNumbers]="{ s: '4', m: '8', l: '2' }"
        >
          <!--sidebar-->
          <ng-container>
            <ng-container *ngTemplateOutlet="sidebar"></ng-container>
          </ng-container>
          <!-- </div> -->
        </div>
        <!-- Col 1 -->
        <!-- Col 2 -->
        <div
          edsCol
          [ngStyle]="{ position: 'relative' }"
          [columnNumbers]="
            colNumbersTwo
              ? { s: '4', m: '8', l: '5' }
              : { s: '4', m: '8', l: '5', push: '-l1' }
          "
        >
          <div
            id="insightScrollPosition"
            edsFlexbox
            flexWrap="wrap-reverse"
            alignItems="center"
            justifyContent="space-between"
          >
            <ng-container *ngIf="totalRecords">
              <p edsSpacing="none" aria-live="polite">
                {{ translationLabel?.showing }}
                <strong>{{ visibleRecords }}</strong>
                {{ translationLabel?.of }}
                <strong>{{ totalRecords }}</strong>
              </p>
            </ng-container>

            <!-- Current articles -->
            <div *ngIf="displayOptions?.enableArchived && isHandheld">
              <eds-flyout-menu
                theme="basic"
                [title]="selectedArticleType"
                [items]="filtersData.items"
                alignPosition="right"
                ariaLabelledby="BasicMenuControl"
                [isNonLinkableClickAction]="true"
                (menuItemSelectedWithIndexOutput)="selectArticleType($event)"
              ></eds-flyout-menu>
            </div>
          </div>
          <div edsSpacing="lg"></div>
          <div *ngIf="!results.length && !isLoading">
            <p class="large bold">{{ translationLabel?.noRecordFound }}</p>
          </div>
          <div *ngIf="!results.length && isLoading">
            <p class="large bold">{{ translationLabel?.loading }}</p>
          </div>

          <div>
            <!-- List View on desktop -->
            <div *ngIf="selectedTab === 'listView' && !isHandheld">
              <ng-container *ngIf="results?.length">
                <div *ngFor="let result of results">
                  <div edsSpacing="lg">
                    <ng-container
                      *ngTemplateOutlet="
                        articleCard;
                        context: {
                          result: result,
                          isCompact: true
                        }
                      "
                    ></ng-container>
                  </div>
                </div>
              </ng-container>
            </div>

            <!-- List view on tablet and mobile -->
            <div *ngIf="selectedTab === 'listView' && isHandheld">
              <ng-container *ngIf="results?.length">
                <div *ngFor="let result of results">
                  <div edsSpacing="lg">
                    <ng-container
                      *ngTemplateOutlet="
                        articleCard;
                        context: {
                          result: result,
                          isCompact: true
                        }
                      "
                    ></ng-container>
                  </div>
                </div>
              </ng-container>
            </div>

            <!-- Grid view -->
            <div *ngIf="selectedTab === 'gridView'">
              <ng-container *ngIf="!sideBarDocumentRef && results?.length">
                <div
                  [edsSubGrid]="'layout-0'"
                  edsSubGridTablet="layout-0"
                  edsSubGridGap="md"
                  edsSubGridTabletGap="md"
                >
                  <div
                    [edsSubGrid]="'layout-2'"
                    edsSubGridTablet="layout-1"
                    edsSubGridGap="md"
                    edsSubGridTabletGap="md"
                  >
                    <div *ngFor="let result of results" edsSpacing="lg">
                      <ng-container
                        *ngTemplateOutlet="
                          articleCard;
                          context: {
                            result: result,
                            isCompact: false
                          }
                        "
                      ></ng-container>
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="sideBarDocumentRef && results?.length">
                <div
                  [edsSubGrid]="'layout-3'"
                  edsSubGridTablet="layout-0"
                  edsSubGridGap="md"
                  edsSubGridTabletGap="md"
                >
                  <div
                    [edsSubGrid]="'layout-1'"
                    edsSubGridTablet="layout-1"
                    edsSubGridGap="md"
                    edsSubGridTabletGap="md"
                  >
                    <ng-container
                      *ngIf="
                        sideBarDocumentRef?.contentTop &&
                        sideBarDocumentRef?.contentBottom &&
                        !sideBarDocumentRef?.collections?.length
                      "
                    >
                      <div
                        *ngFor="let result of results | slice: 0:2"
                        edsSpacing="lg"
                      >
                        <ng-container
                          *ngTemplateOutlet="
                            articleCard;
                            context: {
                              result: result,
                              isCompact: false
                            }
                          "
                        ></ng-container>
                      </div>
                    </ng-container>
                    <ng-container
                      *ngIf="
                        sideBarDocumentRef?.contentTop &&
                        sideBarDocumentRef?.contentBottom &&
                        sideBarDocumentRef?.collections?.length
                      "
                    >
                      <div
                        *ngFor="let result of results | slice: 0:4"
                        edsSpacing="lg"
                      >
                        <ng-container
                          *ngTemplateOutlet="
                            articleCard;
                            context: {
                              result: result,
                              isCompact: false
                            }
                          "
                        ></ng-container>
                      </div>
                    </ng-container>
                  </div>
                  <div *ngIf="!isHandheld">
                    <div edsSpacing="xxl">
                      <ng-container *ngTemplateOutlet="sidebar"></ng-container>
                    </div>
                  </div>
                </div>
                <div
                  [edsSubGrid]="'layout-0'"
                  edsSubGridTablet="layout-0"
                  edsSubGridGap="md"
                  edsSubGridTabletGap="md"
                >
                  <div
                    [edsSubGrid]="'layout-2'"
                    edsSubGridTablet="layout-1"
                    edsSubGridGap="md"
                    edsSubGridTabletGap="md"
                  >
                    <ng-container *ngIf="results?.length">
                      <ng-container
                        *ngIf="
                          sideBarDocumentRef?.contentTop &&
                          sideBarDocumentRef?.contentBottom &&
                          !sideBarDocumentRef?.collections?.length
                        "
                      >
                        <div
                          *ngFor="let result of results | slice: 2"
                          edsSpacing="lg"
                        >
                          <ng-container
                            *ngTemplateOutlet="
                              articleCard;
                              context: {
                                result: result,
                                isCompact: false
                              }
                            "
                          ></ng-container>
                        </div>
                      </ng-container>
                      <ng-container
                        *ngIf="
                          sideBarDocumentRef?.contentTop &&
                          sideBarDocumentRef?.contentBottom &&
                          sideBarDocumentRef?.collections?.length
                        "
                      >
                        <div
                          *ngFor="let result of results | slice: 4"
                          edsSpacing="lg"
                        >
                          <ng-container
                            *ngTemplateOutlet="
                              articleCard;
                              context: {
                                result: result,
                                isCompact: false
                              }
                            "
                          ></ng-container>
                        </div>
                      </ng-container>
                    </ng-container>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>

          <div edsSpacing="lg"></div>
          <div
            edsFlexbox
            alignItems="center"
            justifyContent="space-between"
            [edsSpacing]="'lg'"
            *ngIf="totalRecords > options.counters.pages"
          >
            <div
              edsSpacing="none"
              [class.insights-library__pagination--is-not-handheld]="
                !isHandheld
              "
            >
              <eds-pagination
                [prevPageText]="translationLabel?.previous"
                [nextPageText]="translationLabel?.next"
                [pages]="totalPages"
                [pageTitle]="pageTitle"
                (pageChanged)="goToPage($event)"
                [ariaLabelGoToPage]="'common.ariaLabelGoToPage' | translate"
                [ariaLabelPageNav]="'common.navigationLandmark' | translate"
              ></eds-pagination>
            </div>
            <!-- Item Per Page Dropdown -->
            <eds-dropdown
              *ngIf="!isHandheld"
              ariaLabel="Dropdown"
              [dropdownId]="'ItemsPerPageBottomDD'"
              [label]="translationLabel?.itemsPerPage"
              [items]="itemsPerPageOption"
              [preselectedValue]="pageSize"
              (dropdownChange)="onDropdownChange($event)"
              edsPadding
              edsPaddingLeft="none"
            ></eds-dropdown>
          </div>
          <ng-template
            let-result="result"
            let-isCompact="isCompact"
            #articleCard
          >
            <eds-card-article
              [hasImage]="result._source?.imgSrc ? true : false"
              [imgSrc]="result._source?.imgSrc"
              [title]="result._source?.title"
              [description]="result._source?.description"
              [date]="result._source?.referenceDate"
              [href]="result._source?.relativePath"
              [isCompact]="isCompact"
              [logoLink]="result._source?.SIM?.logoSrc"
              [altLogoText]="result._source?.SIM?.logoAltText | titlecase"
              [logoTheme]="result._source?.SIM?.logoTheme"
              [logoBackgroundColor]="result._source?.SIM?.logoBackgroundColor"
              [subTitle]="
                result._source?.isArchived
                  ? this.translationLabel?.archived
                  : ''
              "
            >
            </eds-card-article>
            <ft-insights-tags
              [insightsTags]="result._source"
            ></ft-insights-tags>
          </ng-template>
        </div>

        <!-- Col 3 -->

        <div
          *ngIf="sideBarDocumentRef"
          edsCol
          [ngStyle]="{ position: 'relative' }"
          [columnNumbers]="
            colNumbersThree
              ? { s: '4', m: '8', l: '3' }
              : { s: '4', m: '8', l: '3', push: '-l1' }
          "
        >
          <!-- Current articles -->
          <div *ngIf="displayOptions?.enableArchived && !isHandheld">
            <eds-flyout-menu
              theme="basic"
              [title]="selectedArticleType"
              [items]="filtersData.items"
              ariaLabelledby="BasicMenuControl"
              [isNonLinkableClickAction]="true"
              (menuItemSelectedWithIndexOutput)="selectArticleType($event)"
              alignPosition="right"
            ></eds-flyout-menu>
          </div>

          <!--sidebar-->
          <ng-container *ngIf="sideBarDocumentRef">
            <ft-insights-sidebar
              [documentData]="sideBarDocumentRef"
              [page]="page"
              [enableTopFour]="true"
              [translationLabel]="translationLabel"
              [enableCollections]="false"
            >
            </ft-insights-sidebar>
          </ng-container>
        </div>

        <!-- col 3 -->
        <!-- main col -->
      </div>
    </div>
  </section>
</ng-container>

<ng-container *ngIf="isDebugMode">
  <ft-insights-report></ft-insights-report>
</ng-container>

<ng-template #resultsList>
  <div
    id="insightScrollPosition"
    edsFlexbox
    flexWrap="wrap-reverse"
    alignItems="center"
    justifyContent="space-between"
  >
    <ng-container *ngIf="totalRecords">
      <p edsSpacing="none" aria-live="polite">
        {{ translationLabel?.showing }}
        <strong>{{ visibleRecords }}</strong>
        {{ translationLabel?.of }}
        <strong>{{ totalRecords }}</strong>
      </p>
    </ng-container>

    <!-- Current articles -->
    <div *ngIf="displayOptions?.enableArchived && isHandheld">
      <eds-flyout-menu
        theme="basic"
        [title]="selectedArticleType"
        [items]="filtersData.items"
        widthSize="md"
        ariaLabelledby="BasicMenuControl"
        [isNonLinkableClickAction]="true"
        (menuItemSelectedWithIndexOutput)="selectArticleType($event)"
      ></eds-flyout-menu>
    </div>
  </div>
  <div edsSpacing="lg"></div>
  <div *ngIf="!results.length && !isLoading">
    <p class="large bold">{{ translationLabel?.noRecordFound }}</p>
  </div>
  <div *ngIf="!results.length && isLoading">
    <p class="large bold">{{ translationLabel?.loading }}</p>
  </div>

  <div>
    <!-- List View on desktop -->
    <div *ngIf="selectedTab === 'listView' && !isHandheld">
      <ng-container *ngIf="results?.length">
        <div *ngFor="let result of results">
          <div edsSpacing="lg">
            <ng-container
              *ngTemplateOutlet="
                articleCard;
                context: {
                  result: result,
                  isCompact: true
                }
              "
            ></ng-container>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- List view on tablet and mobile -->
    <div *ngIf="selectedTab === 'listView' && isHandheld">
      <ng-container *ngIf="results?.length">
        <div *ngFor="let result of results">
          <div edsSpacing="lg">
            <ng-container
              *ngTemplateOutlet="
                articleCard;
                context: {
                  result: result,
                  isCompact: true
                }
              "
            ></ng-container>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- Grid view -->
    <div *ngIf="selectedTab === 'gridView'">
      <ng-container *ngIf="!sideBarDocumentRef && results?.length">
        <div
          [edsSubGrid]="'layout-0'"
          edsSubGridTablet="layout-0"
          edsSubGridGap="md"
          edsSubGridTabletGap="md"
        >
          <div
            [edsSubGrid]="'layout-2'"
            edsSubGridTablet="layout-1"
            edsSubGridGap="md"
            edsSubGridTabletGap="md"
          >
            <div *ngFor="let result of results" edsSpacing="lg">
              <ng-container
                *ngTemplateOutlet="
                  articleCard;
                  context: {
                    result: result,
                    isCompact: false
                  }
                "
              ></ng-container>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="sideBarDocumentRef && results?.length">
        <div
          [edsSubGrid]="'layout-3'"
          edsSubGridTablet="layout-0"
          edsSubGridGap="md"
          edsSubGridTabletGap="md"
        >
          <div
            [edsSubGrid]="'layout-1'"
            edsSubGridTablet="layout-1"
            edsSubGridGap="md"
            edsSubGridTabletGap="md"
          >
            <ng-container
              *ngIf="
                sideBarDocumentRef?.contentTop &&
                sideBarDocumentRef?.contentBottom &&
                !sideBarDocumentRef?.collections?.length
              "
            >
              <div *ngFor="let result of results | slice: 0:2" edsSpacing="lg">
                <ng-container
                  *ngTemplateOutlet="
                    articleCard;
                    context: {
                      result: result,
                      isCompact: false
                    }
                  "
                ></ng-container>
              </div>
            </ng-container>
            <ng-container
              *ngIf="
                sideBarDocumentRef?.contentTop &&
                sideBarDocumentRef?.contentBottom &&
                sideBarDocumentRef?.collections?.length
              "
            >
              <div *ngFor="let result of results | slice: 0:4" edsSpacing="lg">
                <ng-container
                  *ngTemplateOutlet="
                    articleCard;
                    context: {
                      result: result,
                      isCompact: false
                    }
                  "
                ></ng-container>
              </div>
            </ng-container>
          </div>
          <div *ngIf="!isHandheld">
            <div edsSpacing="xxl">
              <ng-container *ngTemplateOutlet="sidebar"></ng-container>
            </div>
          </div>
        </div>
        <div
          [edsSubGrid]="'layout-0'"
          edsSubGridTablet="layout-0"
          edsSubGridGap="md"
          edsSubGridTabletGap="md"
        >
          <div
            [edsSubGrid]="'layout-2'"
            edsSubGridTablet="layout-1"
            edsSubGridGap="md"
            edsSubGridTabletGap="md"
          >
            <ng-container *ngIf="results?.length">
              <ng-container
                *ngIf="
                  sideBarDocumentRef?.contentTop &&
                  sideBarDocumentRef?.contentBottom &&
                  !sideBarDocumentRef?.collections?.length
                "
              >
                <div *ngFor="let result of results | slice: 2" edsSpacing="lg">
                  <ng-container
                    *ngTemplateOutlet="
                      articleCard;
                      context: {
                        result: result,
                        isCompact: false
                      }
                    "
                  ></ng-container>
                </div>
              </ng-container>
              <ng-container
                *ngIf="
                  sideBarDocumentRef?.contentTop &&
                  sideBarDocumentRef?.contentBottom &&
                  sideBarDocumentRef?.collections?.length
                "
              >
                <div *ngFor="let result of results | slice: 4" edsSpacing="lg">
                  <ng-container
                    *ngTemplateOutlet="
                      articleCard;
                      context: {
                        result: result,
                        isCompact: false
                      }
                    "
                  ></ng-container>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <div edsSpacing="lg"></div>
  <div edsRow *ngIf="totalRecords > options.counters.pages">
    <eds-pagination
      edsCol
      [edsSpacing]="'lg'"
      [prevPageText]="translationLabel?.previous"
      [nextPageText]="translationLabel?.next"
      [pages]="totalPages"
      [pageTitle]="pageTitle"
      (pageChanged)="goToPage($event)"
      [ariaLabelGoToPage]="'common.ariaLabelGoToPage' | translate"
      [ariaLabelPageNav]="'common.navigationLandmark' | translate"
    ></eds-pagination>
  </div>
  <ng-template let-result="result" let-isCompact="isCompact" #articleCard>
    <eds-card-article
      [reduceImageSize]="compactImage"
      [hasImage]="result._source?.imgSrc ? true : false"
      [imgSrc]="result._source?.imgSrc"
      [title]="result._source?.title"
      [description]="result._source?.description"
      [date]="result._source?.referenceDate"
      [href]="result._source?.relativePath"
      [isCompact]="isCompact"
      [logoLink]="result._source?.SIM?.logoSrc"
      [altLogoText]="result._source?.SIM?.logoAltText | titlecase"
      [logoTheme]="result._source?.SIM?.logoTheme"
      [logoBackgroundColor]="result._source?.SIM?.logoBackgroundColor"
      [subTitle]="
        result._source?.isArchived ? this.translationLabel?.archived : ''
      "
    >
    </eds-card-article>
    <ft-insights-tags [insightsTags]="result._source"></ft-insights-tags>
  </ng-template>
</ng-template>

<ng-template #sidebar>
  <ft-insights-sidebar
    [documentData]="sideBarDocumentRef"
    [page]="page"
    [enableTopFour]="false"
    [translationLabel]="translationLabel"
  >
  </ft-insights-sidebar>
</ng-template>
